/*
 * Copyright (c) 2022 CalAmp Corp. All Rights Reserved
 */
import React from 'react';
import {dlsColor} from '../theme/theme';
import {IconProps} from '../types/types';
import useIconDLS from './useIconDLS';

/*
 * Defines the Design Language System (DLS) SSO Config Icon component.
 */
export const SSOConfigIcon = React.memo((props: IconProps) => {
  const {iconColor} = useIconDLS(props);
  return (
    <svg width='28' height='28' viewBox='0 0 28 28' fill='none'>
      <g clipPath='url(#prefix__clip0)'>
        <path d='M8.58325 14.8417C8.0777 14.8417 7.64436 14.6611 7.28325 14.3C6.92214 13.9389 6.74159 13.5056 6.74159 13C6.74159 12.4944 6.92214 12.0611 7.28325 11.7C7.64436 11.3389 8.0777 11.1583 8.58325 11.1583C9.08881 11.1583 9.52214 11.3389 9.88325 11.7C10.2444 12.0611 10.4249 12.4944 10.4249 13C10.4249 13.5056 10.2444 13.9389 9.88325 14.3C9.52214 14.6611 9.08881 14.8417 8.58325 14.8417ZM8.58325 19.5C6.7777 19.5 5.24297 18.8681 3.97909 17.6042C2.7152 16.3403 2.08325 14.8056 2.08325 13C2.08325 11.1944 2.7152 9.65972 3.97909 8.39583C5.24297 7.13194 6.7777 6.5 8.58325 6.5C9.88325 6.5 11.0208 6.80694 11.9958 7.42083C12.9708 8.03472 13.7381 8.96458 14.2978 10.2104H23.9395L26.9999 13.2708L22.477 17.4146L20.0937 15.6813L17.7103 17.4146L15.6791 15.7896H14.2978C13.8464 16.8729 13.1378 17.7622 12.1718 18.4573C11.2058 19.1524 10.0096 19.5 8.58325 19.5ZM8.58325 17.875C9.63047 17.875 10.5964 17.5274 11.4812 16.8323C12.3659 16.1372 12.9346 15.2479 13.1874 14.1646H16.2749L17.7374 15.3833L20.1208 13.6771L22.3416 15.3563L24.6437 13.2167L23.2624 11.8354H13.1874C12.9708 10.8243 12.4291 9.95312 11.5624 9.22187C10.6958 8.49062 9.7027 8.125 8.58325 8.125C7.22908 8.125 6.07804 8.59896 5.13013 9.54688C4.18221 10.4948 3.70825 11.6458 3.70825 13C3.70825 14.3542 4.18221 15.5052 5.13013 16.4531C6.07804 17.401 7.22908 17.875 8.58325 17.875Z'
          fill={iconColor}/>
      </g>
      <defs>
        <clipPath id='prefix__clip0'>
          <rect width='26' height='26' fill={dlsColor('grey1')} />
        </clipPath>
      </defs>
    </svg>
  );
});
